import {
  MEGAMENU_ITEM_BILLING,
  MEGAMENU_ITEM_CLAIMS_AND_REQUESTS,
  MEGAMENU_ITEM_CONSUMPTION,
  MEGAMENU_ITEM_CREDIT,
  MEGAMENU_ITEM_GIGAMARKET,
  MEGAMENU_ITEM_LOYALTY,
  MEGAMENU_ITEM_CAMPAIGN_UNIVERSE,
  MEGAMENU_ITEM_PRODUCTS_AND_SERVICES,
  MEGAMENU_ITEM_DASHBOARD,
} from '@oskecare/fe-utilities/lib/constants/megamenu';
import { Redirect } from '@oskecare/infrastructure/src/modules/Router/models/Redirect.js';
import { Route } from '@oskecare/infrastructure/src/modules/Router/models/Route.js';
import { Breadcrumb } from '@oskecare/infrastructure/src/modules/Router/models/Breadcrumb.js';
import { config } from './config.js';
import billing from './pages/billing.js';
import consumption from './pages/consumption.js';
import consumptionActual from './pages/consumption-actual.js';
import consumptionList from './pages/consumption-list.js';
import consumptionPrevious from './pages/consumption-previous.js';
import consumptionPurchaseHistory from './pages/consumption-purchase-history.js';
import consumptionPurchaseHistoryDetail from './pages/consumption-purchase-history-detail.js';
import credit from './pages/credit.js';
import creditPostpaid from './pages/credit-postpaid.js';
import creditRefill from './pages/credit-refill.js';
import creditRefillPostpaid from './pages/credit-refill-postpaid.js';
import productsAndServicesCrossroad from './pages/products-and-services-crossroad.js';
import productsAndServicesDetail from './pages/products-and-services-detail.js';
import productsAndServicesOverview from './pages/products-and-services-overview.js';
import productsAndServicesEligibleList from './pages/products-and-services-eligible-list.js';
import productsAndServicesTogetherFree from './pages/products-and-services-together-free.js';
import dataSharing from './pages/data-sharing.js';
import dataMerge from './pages/data-merge.js';
import love from './pages/love.js';
import gigamarket from './pages/gigamarket.js';
import accountSettings from './pages/account-settings.js';
import mySim from './pages/my-sim.js';
import eSimActivation from './pages/e-sim-activation.js';
import eSimDeactivation from './pages/e-sim-deactivation.js';
import eSimRegenerate from './pages/e-sim-regenerate.js';
import masterSnManagement from './pages/master-sn-management.js';
import claimsAndRequests from './pages/claims.js';
import claimsAndRequestsDetail from './pages/claims-detail.js';
import dashboard from './pages/dashboard.js';
import payment from './pages/payment.js';
import b2b from './pages/b2b.js';
import LoyaltyCelebrations from './pages/loyalty-celebrations.js';
import loyaltyDashboard from './pages/loyalty-dashboard.js';
import loyaltyMissionList from './pages/loyalty-mission-list.js';
import LoyaltyCompetitions from './pages/loyalty-competition-detail.js';
import LoyaltyCouponsList from './pages/loyalty-coupon-list.js';
import LoyaltyCouponDetail from './pages/loyalty-coupon-detail.js';
import campaignUniverse from './pages/campaign-universe.js';
import apiTester from './pages/api-tester.js';

const { linkConfiguration } = config;

const accountSettingsRoutes = [
  new Route({
    path: '/nastavenie-uctu',
    title: 'Nastavenie účtu',
    template: accountSettings,
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Nastavenie účtu',
        link: linkConfiguration.accountSettingsLink,
      }),
    ],
    heading: 'Nastavenie účtu',
    shouldRenderSnPicker: true,
    type: 'account.setup',
  }),
  new Route({
    path: '/nastavenie-uctu/sprava-sim-karty',
    title: 'Správa SIM karty',
    template: mySim,
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Nastavenie účtu',
        link: linkConfiguration.accountSettingsLink,
        dynamicQuery: ['sn'],
      }),
      new Breadcrumb({
        name: 'Správa SIM karty',
        link: linkConfiguration.mySimLink,
      }),
    ],
    shouldRenderSnPicker: true,
    hasCustomPageViewHandling: true,
  }),
  new Route({
    path: '/nastavenie-uctu/sprava-sim-karty/aktivacia-esim',
    title: 'Aktivácia eSIM',
    template: eSimActivation,
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Nastavenie účtu',
        link: linkConfiguration.accountSettingsLink,
        dynamicQuery: ['sn'],
      }),
      new Breadcrumb({
        name: 'Správa SIM karty',
        link: linkConfiguration.mySimLink,
        dynamicQuery: ['sn'],
      }),
      new Breadcrumb({
        name: 'Aktivácia eSIM',
        link: linkConfiguration.eSimActivationLink,
      }),
    ],
    hasCustomPageViewHandling: true,
  }),
  new Route({
    path: '/nastavenie-uctu/sprava-sim-karty/deaktivacia-esim',
    title: 'Deaktivácia eSIM',
    template: eSimDeactivation,
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Nastavenie účtu',
        link: linkConfiguration.accountSettingsLink,
        dynamicQuery: ['sn'],
      }),
      new Breadcrumb({
        name: 'Správa SIM karty',
        link: linkConfiguration.mySimLink,
        dynamicQuery: ['sn'],
      }),
      new Breadcrumb({
        name: 'Deaktivácia eSIM',
        link: linkConfiguration.eSimDeactivationLink,
      }),
    ],
    hasCustomPageViewHandling: true,
    isWip: true, // TODO: remove after physical SIM management release
  }),
  new Route({
    path: '/nastavenie-uctu/sprava-sim-karty/vygenerovanie-esim',
    title: 'Vygenerovanie eSIM',
    template: eSimRegenerate,
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Nastavenie účtu',
        link: linkConfiguration.accountSettingsLink,
        dynamicQuery: ['sn'],
      }),
      new Breadcrumb({
        name: 'Správa SIM karty',
        link: linkConfiguration.mySimLink,
        dynamicQuery: ['sn'],
      }),
      new Breadcrumb({
        name: 'Vygenerovanie eSIM',
        link: linkConfiguration.eSimRegenerateLink,
      }),
    ],
    hasCustomPageViewHandling: true,
  }),
  new Route({
    path: '/nastavenie-uctu/hlavny-ucet',
    title: 'Hlavný účet',
    template: masterSnManagement,
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Nastavenie účtu',
        link: linkConfiguration.accountSettingsLink,
        dynamicQuery: ['sn'],
      }),
      new Breadcrumb({
        name: 'Hlavný účet',
        link: linkConfiguration.masterSnManagement,
      }),
    ],
    type: 'account.setup',
    section: 'master.change',
  }),
];
const consumptionRoutes = [
  new Route({
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Spotreba',
        link: linkConfiguration.consumptionLink,
      }),
    ],
    activeMenuItem: MEGAMENU_ITEM_CONSUMPTION,
    path: '/spotreba',
    title: 'Spotreba',
    description:
      'Získajte prehľad o vašej aktuálnej spotrebe, predošlej spotrebe a pozrite si rozpis vašich hovorov.',
    template: consumption,
    type: 'account.consumption',
    section: 'myAccounts',
  }),
  new Route({
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Spotreba',
        link: linkConfiguration.consumptionLink,
      }),
      new Breadcrumb({
        name: 'Aktuálna spotreba',
        link: linkConfiguration.actualDetailConsumptionLink,
      }),
    ],
    activeMenuItem: MEGAMENU_ITEM_CONSUMPTION,
    path: '/spotreba/aktualna-spotreba',
    title: 'Spotreba: Aktuálna spotreba',
    description: 'Získajte prehľad o vašej aktuálnej spotrebe',
    template: consumptionActual,
    shouldRenderSnPicker: true,
    type: 'account.consumption',
    section: 'currentConsumption',
  }),
  new Route({
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Spotreba',
        link: linkConfiguration.consumptionLink,
      }),
      new Breadcrumb({
        name: 'Predošlá spotreba',
        link: linkConfiguration.previousConsumptionLink,
      }),
    ],
    activeMenuItem: MEGAMENU_ITEM_CONSUMPTION,
    path: '/spotreba/predosla-spotreba',
    title: 'Spotreba: Predošlá spotreba',
    template: consumptionPrevious,
    shouldRenderSnPicker: true,
    type: 'account.consumption',
    section: 'previousConsumption',
  }),
  new Route({
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Spotreba',
        link: linkConfiguration.consumptionLink,
      }),
      new Breadcrumb({
        name: 'História nákupov',
        link: linkConfiguration.previousConsumptionLink,
      }),
    ],
    activeMenuItem: MEGAMENU_ITEM_CONSUMPTION,
    path: '/spotreba/historia-nakupov',
    title: 'Spotreba: História nákupov',
    template: consumptionPurchaseHistory,
    type: 'account.consumption',
    section: 'topUpHistory',
    isWip: true, // TODO: remove before prepaid consumption release
  }),
  new Route({
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Spotreba',
        link: linkConfiguration.consumptionLink,
      }),
      new Breadcrumb({
        name: 'História nákupov',
        link: linkConfiguration.consumptionPurchaseHistoryLink,
      }),
      new Breadcrumb({
        name: '[DATE]',
        link: linkConfiguration.consumptionPurchaseHistoryLink,
      }),
    ],
    activeMenuItem: MEGAMENU_ITEM_CONSUMPTION,
    path: '/spotreba/historia-nakupov/:purchase',
    title: 'Spotreba: História nákupov',
    template: consumptionPurchaseHistoryDetail,
    type: 'account.consumption',
    section: 'topUpHistory',
    isWip: true, // TODO: remove before prepaid consumption release
  }),
  new Route({
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Spotreba',
        link: linkConfiguration.consumptionLink,
      }),
      new Breadcrumb({
        name: 'Podrobný výpis',
        link: linkConfiguration.PRH_ConsumptionLink,
      }),
    ],
    activeMenuItem: MEGAMENU_ITEM_CONSUMPTION,
    path: '/spotreba/podrobny-vypis',
    title: 'Spotreba: Podrobný výpis',
    description: 'Získajte detailný prehľad vašich hovorov.',
    template: consumptionList,
    shouldRenderSnPicker: true,
    type: 'account.consumption',
    section: 'consumptionDetail',
  }),
];
const creditRoutes = [
  new Route({
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Kredit',
        link: linkConfiguration.creditLink,
      }),
    ],
    activeMenuItem: MEGAMENU_ITEM_CREDIT,
    path: '/kredit',
    title: 'Kredit',
    template: credit,
    heading: 'Kredit',
    type: 'account.topUp',
    section: 'prepaidTopUpOverview',
  }),
  new Route({
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Moje produkty a služby',
        link: linkConfiguration.productsAndServicesLink,
      }),
      new Breadcrumb({
        name: '[NICKNAME] • [SN]',
        link: linkConfiguration.productsAndServicesOverviewLink,
        dynamicQuery: ['sn'],
      }),
      new Breadcrumb({
        name: 'Kredit',
        link: linkConfiguration.postpaidCreditLink,
      }),
    ],
    activeMenuItem: MEGAMENU_ITEM_PRODUCTS_AND_SERVICES,
    path: '/produkty-a-sluzby/kredit',
    title: 'Kredit',
    template: creditPostpaid,
    shouldRenderSnPicker: true,
    heading: 'Kredit',
    type: 'account.topUp',
    section: 'postpaidTopUpOverview',
  }),
  new Route({
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Kredit',
        link: linkConfiguration.creditLink,
      }),
      new Breadcrumb({
        name: 'Automatické dobitie',
        link: linkConfiguration.creditAutomaticRefillLink,
      }),
    ],
    activeMenuItem: MEGAMENU_ITEM_CREDIT,
    path: '/kredit/automaticke-dobitie',
    title: 'Kredit',
    template: creditRefill,
    type: 'account.topUp',
    section: 'prepaidAutopay',
  }),
  new Route({
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Moje produkty a služby',
        link: linkConfiguration.productsAndServicesLink,
      }),
      new Breadcrumb({
        name: '[NICKNAME] • [SN]',
        link: linkConfiguration.productsAndServicesOverviewLink,
        dynamicQuery: ['sn'],
      }),
      new Breadcrumb({
        name: 'Kredit',
        link: linkConfiguration.postpaidCreditLink,
        dynamicQuery: ['sn'],
      }),
      new Breadcrumb({
        name: 'Automatické dobitie',
        link: linkConfiguration.postpaidCreditAutomaticRefillLink,
      }),
    ],
    activeMenuItem: MEGAMENU_ITEM_PRODUCTS_AND_SERVICES,
    path: '/produkty-a-sluzby/kredit/automaticke-dobitie',
    title: 'Kredit',
    template: creditRefillPostpaid,
    type: 'account.topUp',
    section: 'postpaidAutopay',
  }),
];
const invoicesRoutes = [
  new Route({
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Faktúry',
        link: linkConfiguration.invoiceLink,
      }),
    ],
    activeMenuItem: MEGAMENU_ITEM_BILLING,
    path: '/faktury',
    title: 'Faktúry',
    description:
      'Prehľad vašich faktúr na jednom mieste s jednoduchou možnosťou ich uhradiť pomocou platobnej karty, alebo internet bankingu.',
    template: billing,
    heading: 'Faktúry',
    type: 'account.invoices',
  }),
  new Route({
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Faktúry',
        link: linkConfiguration.invoiceLink,
      }),
      new Breadcrumb({
        name: 'Platba faktúry',
        link: linkConfiguration.invoicePayLink,
      }),
    ],
    activeMenuItem: MEGAMENU_ITEM_BILLING,
    path: '/faktury/platba',
    title: 'Úhrada faktúry',
    template: payment,
    heading: 'Platba faktúry',
    type: 'account.invoiceDetail',
  }),
];
const productsAndServicesRoutes = [
  new Route({
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Moje produkty a služby',
        link: linkConfiguration.productsAndServicesLink,
      }),
    ],
    activeMenuItem: MEGAMENU_ITEM_PRODUCTS_AND_SERVICES,
    path: '/produkty-a-sluzby',
    title: 'Moje produkty a služby',
    template: productsAndServicesCrossroad,
    heading: 'Moje produkty a služby',
    type: 'account.services',
    section: 'myServices',
  }),
  new Route({
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Moje produkty a služby',
        link: linkConfiguration.productsAndServicesLink,
      }),
      new Breadcrumb({
        name: 'Orange LOVE',
        link: linkConfiguration.loveLink,
      }),
    ],
    activeMenuItem: MEGAMENU_ITEM_PRODUCTS_AND_SERVICES,
    path: '/produkty-a-sluzby/love',
    title: 'Orange LOVE',
    template: love,
    heading: 'Orange LOVE',
    type: 'account.services',
    section: 'lovePackage.detail',
  }),
  new Route({
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Moje produkty a služby',
        link: linkConfiguration.productsAndServicesLink,
      }),
      new Breadcrumb({
        name: '[NICKNAME] • [SN]',
        link: linkConfiguration.productsAndServicesOverviewLink,
      }),
    ],
    activeMenuItem: MEGAMENU_ITEM_PRODUCTS_AND_SERVICES,
    path: '/produkty-a-sluzby/prehlad',
    title: 'Moje produkty a služby: Prehľad',
    description:
      'Prehľad služieb vám poskytuje všetky najdôležitejšie údaje o vašich aktívnych službách a ponúka zoznam ďalších služieb na aktiváciu.',
    template: productsAndServicesOverview,
    shouldRenderSnPicker: true,
    type: 'account.services',
    section: 'servicesOveview',
  }),
  new Route({
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Moje produkty a služby',
        link: linkConfiguration.productsAndServicesLink,
      }),
      new Breadcrumb({
        name: '[NICKNAME] • [SN]',
        link: linkConfiguration.productsAndServicesOverviewLink,
        dynamicQuery: ['sn'],
      }),
      new Breadcrumb({
        name: 'Detail služby',
        link: linkConfiguration.productsAndServicesDetailLink,
      }),
    ],
    activeMenuItem: MEGAMENU_ITEM_PRODUCTS_AND_SERVICES,
    path: '/produkty-a-sluzby/prehlad/detail',
    title: 'Detail služby',
    template: productsAndServicesDetail,
    type: 'account.services',
    section: 'serviceDetail',
    shouldRenderSnPicker: true,
    snPickerOnDemandTopic: 'productsAndServicesDetail',
    hasCustomPageViewHandling: true,
  }),
  new Route({
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Moje produkty a služby',
        link: linkConfiguration.productsAndServicesLink,
      }),
      new Breadcrumb({
        name: '[NICKNAME] • [SN]',
        link: linkConfiguration.productsAndServicesOverviewLink,
        dynamicQuery: ['sn'],
      }),
      new Breadcrumb({
        name: 'Navzájom zadarmo',
        link: linkConfiguration.productsAndServicesTogetherFree,
      }),
    ],
    activeMenuItem: MEGAMENU_ITEM_PRODUCTS_AND_SERVICES,
    path: '/produkty-a-sluzby/prehlad/navzajom-zadarmo',
    title: 'Navzájom zadarmo',
    description:
      'Nenechávajte si zážitky len pre seba. Podeľte sa o ne s najbližšími so službou Navzájom zadarmo.',
    template: productsAndServicesTogetherFree,
    type: 'account.services',
    section: 'serviceDetail',
    hasCustomPageViewHandling: true,
  }),
  new Route({
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Moje produkty a služby',
        link: linkConfiguration.productsAndServicesLink,
      }),
      new Breadcrumb({
        name: '[NICKNAME] • [SN]',
        link: linkConfiguration.productsAndServicesOverviewLink,
        dynamicQuery: ['sn'],
      }),
      new Breadcrumb({
        name: 'Všetky služby',
        link: linkConfiguration.productsAndServicesEligibleLink,
      }),
    ],
    activeMenuItem: MEGAMENU_ITEM_PRODUCTS_AND_SERVICES,
    path: '/produkty-a-sluzby/prehlad/vsetky-sluzby',
    title: 'Všetky služby',
    template: productsAndServicesEligibleList,
    heading: 'Všetky služby',
    type: 'account.services',
    section: 'allServices',
  }),
  new Route({
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Moje produkty a služby',
        link: linkConfiguration.productsAndServicesLink,
      }),
      new Breadcrumb({
        name: '[NICKNAME] • [SN]',
        link: linkConfiguration.productsAndServicesOverviewLink,
        dynamicQuery: ['sn'],
      }),
      new Breadcrumb({
        name: 'Zdieľam svoje dáta',
        link: linkConfiguration.dataSharingPageLink,
      }),
    ],
    activeMenuItem: MEGAMENU_ITEM_PRODUCTS_AND_SERVICES,
    path: '/produkty-a-sluzby/prehlad/zdielam-svoje-data',
    title: 'Zdieľam svoje dáta',
    template: dataSharing,
    shouldRenderSnPicker: true,
    snPickerOnDemandTopic: 'dataSharing',
    type: 'account.services',
    section: 'serviceDetail',
    hasCustomPageViewHandling: true,
  }),
  new Route({
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Moje produkty a služby',
        link: linkConfiguration.productsAndServicesLink,
      }),
      new Breadcrumb({
        name: '[NICKNAME] • [SN]',
        link: linkConfiguration.productsAndServicesOverviewLink,
        dynamicQuery: ['sn'],
      }),
      new Breadcrumb({
        name: 'Spojenie dát',
        link: linkConfiguration.dataMergePageLink,
      }),
    ],
    activeMenuItem: MEGAMENU_ITEM_PRODUCTS_AND_SERVICES,
    path: '/produkty-a-sluzby/prehlad/spojenie-dat',
    title: 'Spojenie dát',
    template: dataMerge,
    shouldRenderSnPicker: true,
    snPickerOnDemandTopic: 'dataMerge',
    type: 'account.services',
    section: 'serviceDetail',
    hasCustomPageViewHandling: true,
  }),
];
const yoxoRoutes = [
  new Route({
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Yoxo Market',
        link: linkConfiguration.gigamarketLink,
      }),
    ],
    activeMenuItem: MEGAMENU_ITEM_GIGAMARKET,
    path: '/yoxomarket',
    title: 'Yoxo Market',
    description:
      'Kúp si dáta navyše alebo predaj tie, ktoré ti ostanú. Yoxo Market funguje ako burza.',
    template: gigamarket,
    shouldRenderSnPicker: true,
    type: 'account.market',
  }),
];
const loyaltyRoutes = [
  new Route({
    path: '/orange-svojim',
    title: 'Orange Svojim',
    description:
      'V programe Orange Svojim uvidíte benefity a bonusové služby, ktoré od nás čerpáte, a možnosť získať ďalšie. Nájdete v ňom aj všetky darčeky od Orangeu a výhry zo súťaží.',
    template: loyaltyDashboard,
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Orange Svojim',
        link: linkConfiguration.loyaltyDashboardLink,
      }),
    ],
    activeMenuItem: MEGAMENU_ITEM_LOYALTY,
    heading: 'Orange Svojim',
    shouldRenderSnPicker: true,
    type: 'account.loyalty',
    section: 'dashboard',
    hasCustomPageViewHandling: true,
  }),
  new Route({
    path: '/orange-svojim/misie',
    title: 'Orange Svojim: Misie',
    description:
      'Plňte misie a získajte viac výhod. V Orange Svojim môžete plniť misie. Každá misia obsahuje úlohu, za ktorú od nás dostanete bonusovú službu, zľavu alebo inú výhodu.',
    template: loyaltyMissionList,
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Orange Svojim',
        link: linkConfiguration.loyaltyDashboardLink,
        dynamicQuery: ['sn'],
      }),
      new Breadcrumb({
        name: 'Misie',
        link: linkConfiguration.loyaltyMissionsLink,
      }),
    ],
    activeMenuItem: MEGAMENU_ITEM_LOYALTY,
    heading: 'Misie',
    shouldRenderSnPicker: true,
    type: 'account.loyalty',
    section: 'missions.list',
  }),
  new Route({
    path: '/orange-svojim/oslavy',
    title: 'Orange Svojim: Oslavy',
    description:
      'Oslavujme spolu! Pri výnimočných dňoch vám pošleme malý darček, aby ste vedeli, že na vás myslíme. Môžete od nás dostať zľavový kupón na nákup u našich partnerov, dáta zadarmo alebo inú drobnosť.',
    template: LoyaltyCelebrations,
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Orange Svojim',
        link: linkConfiguration.loyaltyDashboardLink,
        dynamicQuery: ['sn'],
      }),
      new Breadcrumb({
        name: 'Oslavy',
        link: linkConfiguration.loyaltyCelebrationsLink,
      }),
    ],
    activeMenuItem: MEGAMENU_ITEM_LOYALTY,
    heading: 'Oslavy',
    shouldRenderSnPicker: true,
    type: 'account.loyalty',
    section: 'celebrations.list',
  }),
  new Route({
    path: '/orange-svojim/odmena-za-vernost',
    title: 'Orange Svojim: Odmena za vernosť',
    description:
      'Oslavujme spolu! Pri výnimočných dňoch vám pošleme malý darček, aby ste vedeli, že na vás myslíme. Môžete od nás dostať zľavový kupón na nákup u našich partnerov, dáta zadarmo alebo inú drobnosť.',
    template: LoyaltyCouponsList,
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Orange Svojim',
        link: linkConfiguration.loyaltyDashboardLink,
        dynamicQuery: ['sn'],
      }),
      new Breadcrumb({
        name: 'Odmena za vernosť',
        link: linkConfiguration.loyaltyCelebrationsCouponsLink,
      }),
    ],
    activeMenuItem: MEGAMENU_ITEM_LOYALTY,
    heading: 'Odmena za vernosť',
    shouldRenderSnPicker: true,
    type: 'account.loyalty',
    section: 'coupons.list',
    isWip: true, // TODO: either remove hidden route or display it again after loyalty coupons future is decided by business
  }),
  new Route({
    path: '/orange-svojim/odmena-za-vernost/:name',
    title: 'Orange Svojim: Zľavový Kupón',
    description:
      'Oslavujme spolu! Pri výnimočných dňoch vám pošleme malý darček, aby ste vedeli, že na vás myslíme. Môžete od nás dostať zľavový kupón na nákup u našich partnerov, dáta zadarmo alebo inú drobnosť.',
    template: LoyaltyCouponDetail,
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Orange Svojim',
        link: linkConfiguration.loyaltyDashboardLink,
        dynamicQuery: ['sn'],
      }),
      new Breadcrumb({
        name: 'Odmena za vernosť',
        link: linkConfiguration.loyaltyCelebrationsCouponsLink,
        dynamicQuery: ['sn'],
      }),
      new Breadcrumb({
        name: 'Zľavový Kupón',
      }),
    ],
    activeMenuItem: MEGAMENU_ITEM_LOYALTY,
    heading: 'Zľavový Kupón',
    type: 'account.loyalty',
    section: 'coupons.detail',
    isWip: true, // TODO: either remove hidden route or display it again after loyalty coupons future is decided by business
  }),
  new Route({
    path: '/orange-svojim/odmena-za-vernost/:name/:id',
    title: 'Orange Svojim: Zľavový Kupón',
    description:
      'Oslavujme spolu! Pri výnimočných dňoch vám pošleme malý darček, aby ste vedeli, že na vás myslíme. Môžete od nás dostať zľavový kupón na nákup u našich partnerov, dáta zadarmo alebo inú drobnosť.',
    template: LoyaltyCouponDetail,
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Orange Svojim',
        link: linkConfiguration.loyaltyDashboardLink,
        dynamicQuery: ['sn'],
      }),
      new Breadcrumb({
        name: 'Odmena za vernosť',
        link: linkConfiguration.loyaltyCelebrationsCouponsLink,
        dynamicQuery: ['sn'],
      }),
      new Breadcrumb({
        name: 'Zľavový Kupón',
      }),
    ],
    activeMenuItem: MEGAMENU_ITEM_LOYALTY,
    heading: 'Zľavový Kupón',
    type: 'account.loyalty',
    section: 'coupons.detail',
    isWip: true, // TODO: either remove hidden route or display it again after loyalty coupons future is decided by business
  }),
  new Route({
    path: '/orange-svojim/prekvapenia',
    title: 'Orange Svojim: Prekvapenie',
    description:
      'Prekvapenie každý mesiac. Pripravujeme pre vás súťaže, v ktorých môžete vyhrať vstupenky na podujatia, elektroniku alebo iné vecné ceny. Stačí pár klikov.',
    template: LoyaltyCompetitions,
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Orange Svojim',
        link: linkConfiguration.loyaltyDashboardLink,
        dynamicQuery: ['sn'],
      }),
      new Breadcrumb({
        name: 'Prekvapenie',
        link: linkConfiguration.loyaltyCompetitionDetailLink,
      }),
    ],
    activeMenuItem: MEGAMENU_ITEM_LOYALTY,
    heading: 'Prekvapenie',
    type: 'account.loyalty',
    section: 'competition.detail',
    shouldRenderSnPicker: true,
  }),
];
const claimsAndRequestsRoutes = [
  new Route({
    path: '/riesenie-problemov',
    title: 'Riešenie problémov',
    template: claimsAndRequests,
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Riešenie problémov',
        link: linkConfiguration.claimsAndRequestsLink,
      }),
    ],
    activeMenuItem: MEGAMENU_ITEM_CLAIMS_AND_REQUESTS,
    heading: 'Riešenie problémov',
    shouldRenderSnPicker: true,
    type: 'account.claims',
    section: 'claimsOverview',
  }),
  new Route({
    path: '/riesenie-problemov/detail',
    title: 'Detail požiadavky',
    template: claimsAndRequestsDetail,
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Riešenie problémov',
        link: linkConfiguration.claimsAndRequestsLink,
        dynamicQuery: ['sn'],
      }),
      new Breadcrumb({
        name: 'Detail požiadavky',
        link: linkConfiguration.claimsAndRequestsDetailLink,
      }),
    ],
    activeMenuItem: MEGAMENU_ITEM_CLAIMS_AND_REQUESTS,
    heading: 'Detail požiadavky',
    shouldRenderSnPicker: true,
    snPickerOnDemandTopic: 'claimsAndRequestsDetail',
    type: 'account.claims',
    section: 'claimDetail',
  }),
];
const campaignRoutes = [
  new Route({
    path: '/ponuky-pre-vas',
    title: 'Ponuky pre vás',
    template: campaignUniverse,
    breadcrumbs: [
      new Breadcrumb({
        name: 'Prehľad',
        link: linkConfiguration.dashboardLink,
      }),
      new Breadcrumb({
        name: 'Ponuky pre vás',
        link: linkConfiguration.campaignUniverseLink,
      }),
    ],
    activeMenuItem: MEGAMENU_ITEM_CAMPAIGN_UNIVERSE,
    heading: 'Ponuky pre vás',
    shouldRenderSnPicker: false,
    type: 'account.promotions',
    section: 'promotionsOverview',
  }),
];

const errorRoutes = [
  new Route({
    path: '/b2b',
    title: 'Môj Orange',
    template: b2b,
    type: 'error',
  }),
];

export const routes = [
  new Route({
    activeMenuItem: MEGAMENU_ITEM_DASHBOARD,
    path: '/',
    description:
      'Majte po ruke všetky dôležité informácie bez toho, aby ste museli niekam chodiť. Pozrite si informácie o vašej spotrebe, plaťte faktúry z mobilu a počítača alebo si pozrite váš profil a služby.',
    template: dashboard,
    heading: 'Prehľad',
    shouldRenderSnPicker: true,
    type: 'account.overview',
  }),
  new Route({
    path: '/api-tester',
    template: apiTester,
    shouldRenderSnPicker: true,
  }),
  ...accountSettingsRoutes,
  ...consumptionRoutes,
  ...creditRoutes,
  ...invoicesRoutes,
  ...yoxoRoutes,
  ...loyaltyRoutes,
  ...productsAndServicesRoutes,
  ...claimsAndRequestsRoutes,
  ...campaignRoutes,
  ...errorRoutes,
];

export const redirects = [
  new Redirect({
    path: '/orange-svojim/oslavy/odmena-za-vernost',
    redirectUrl: '/orange-svojim/odmena-za-vernost',
  }),
  new Redirect({
    path: '/orange-svojim/sutaze',
    redirectUrl: '/orange-svojim/prekvapenia',
  }),
  new Redirect({
    path: '/nastavenie-uctu/moja-sim',
    redirectUrl: '/nastavenie-uctu/sprava-sim-karty',
  }),
  new Redirect({
    path: '/nastavenie-uctu/moja-sim/aktivacia-esim',
    redirectUrl: '/nastavenie-uctu/sprava-sim-karty/aktivacia-esim',
  }),
  new Redirect({
    path: '/nastavenie-uctu/moja-sim/deaktivacia-esim',
    redirectUrl: '/nastavenie-uctu/sprava-sim-karty/deaktivacia-esim',
  }),
  new Redirect({
    path: '/nastavenie-uctu/moja-sim/vygenerovanie-esim',
    redirectUrl: '/nastavenie-uctu/sprava-sim-karty/vygenerovanie-esim',
  }),
  new Redirect({
    path: '/kampane',
    redirectUrl: '/ponuky-pre-vas',
  }),
];
